
// import React, { useState, useEffect } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import swal from "sweetalert";

// const LoginPage = ({ onLogin }) => {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [role, setRole] = useState("");
//   const [roles, setRoles] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [fetchingRoles, setFetchingRoles] = useState(true);
//   const [showPassword, setShowPassword] = useState(false);

//   const navigate = useNavigate();

//   // Check screen size for responsiveness
//   useEffect(() => {
//     const checkScreenSize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     checkScreenSize();
//     window.addEventListener('resize', checkScreenSize);
    
//     return () => window.removeEventListener('resize', checkScreenSize);
//   }, []);

//   // Fetch roles from database
//   useEffect(() => {
//     const fetchRoles = async () => {
//       try {
//         setFetchingRoles(true);
//         const response = await fetch("http://127.0.0.1:5055/api/users/roles", {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error("Failed to fetch roles");
//         }

//         const rolesData = await response.json();
//         setRoles(rolesData);

//         if (rolesData.length > 0) {
//           setRole(rolesData[0].id.toString());
//         }
//       } catch (error) {
//         console.error("Error fetching roles:", error);
//         swal({
//           title: "Connection Error",
//           text: "Unable to load roles. Please check your connection and try again.",
//           icon: "error",
//           button: "Try Again",
//         }).then(() => {
//           fetchRoles();
//         });
//       } finally {
//         setFetchingRoles(false);
//       }
//     };

//     fetchRoles();
//   }, []);

//   // Corrected Login Function - Validates role properly
//   const handleLogin = async (e) => {
//     e.preventDefault();
    
//     if (!username || !password || !role) {
//       swal({
//         title: "Missing Information",
//         text: "Please fill in all fields to continue",
//         icon: "warning",
//         button: "OK",
//       });
//       return;
//     }

//     if (username.length < 3) {
//       swal({
//         title: "Invalid Username",
//         text: "Username must be at least 3 characters long",
//         icon: "warning",
//         button: "OK",
//       });
//       return;
//     }

//     if (password.length < 6) {
//       swal({
//         title: "Weak Password",
//         text: "Password must be at least 6 characters long",
//         icon: "warning",
//         button: "OK",
//       });
//       return;
//     }

//     setLoading(true);

//     swal({
//       title: "Signing In...",
//       text: "Please wait while we authenticate your credentials",
//       icon: "info",
//       buttons: false,
//       closeOnClickOutside: false,
//       closeOnEsc: false,
//     });

//     try {
//       const response = await fetch("http://127.0.0.1:5055/api/users/login", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ 
//           username, 
//           password, 
//           role_id: parseInt(role)
//         }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         swal.close();
        
//         // Validate if the user has permission for the selected role
//         if (data.role && data.role.toLowerCase() !== roles.find(r => r.id === parseInt(role))?.name.toLowerCase()) {
//           swal({
//             title: "Role Mismatch",
//             text: "You don't have permission to access this role. Please select the correct role for your account.",
//             icon: "error",
//             button: "OK",
//           });
//           setLoading(false);
//           return;
//         }

//         swal({
//           title: "Login Successful!",
//           text: `Welcome back, ${username}! Redirecting to dashboard...`,
//           icon: "success",
//           timer: 2000,
//           buttons: false,
//         }).then(() => {
//           localStorage.setItem("token", data.access_token);
//           localStorage.setItem("role", data.role);
//           localStorage.setItem("username", username);
//           localStorage.setItem("userRoleId", role);
          
//           if (onLogin) {
//             onLogin();
//           }
          
//           navigate("/dashboard");
//         });
//       } else {
//         swal({
//           title: "Login Failed",
//           text: data.error || "Invalid credentials. Please try again.",
//           icon: "error",
//           button: "Try Again",
//         });
//       }
//     } catch (err) {
//       swal({
//         title: "Connection Error",
//         text: "Unable to connect to the server. Please check your internet connection and try again.",
//         icon: "error",
//         button: "OK",
//       });
//     }

//     setLoading(false);
//   };

//   const handleRememberMe = () => {
//     swal({
//       title: "Remember Me",
//       text: "This will keep you signed in for 30 days on this device. Only use on trusted devices.",
//       icon: "info",
//       buttons: {
//         cancel: "Cancel",
//         confirm: {
//           text: "I Understand",
//           value: true,
//         }
//       },
//     });
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   // Password Input Component with Show/Hide functionality
//   const PasswordInput = ({ value, onChange, placeholder, style }) => (
//     <div style={{ position: "relative" }}>
//       <input
//         type={showPassword ? "text" : "password"}
//         placeholder={placeholder}
//         value={value}
//         onChange={onChange}
//         style={style}
//       />
//       <button
//         type="button"
//         onClick={togglePasswordVisibility}
//         style={{
//           position: "absolute",
//           right: "12px",
//           top: "50%",
//           transform: "translateY(-50%)",
//           background: "none",
//           border: "none",
//           color: "#024a59",
//           cursor: "pointer",
//           fontSize: "14px",
//           fontWeight: "600",
//           padding: "4px 8px",
//           borderRadius: "4px",
//         }}
//         onMouseOver={(e) => e.target.style.background = "rgba(2, 74, 89, 0.1)"}
//         onMouseOut={(e) => e.target.style.background = "none"}
//       >
//         {showPassword ? "Hide" : "Show"}
//       </button>
//     </div>
//   );

//   // Input Styles
//   const inputStyles = {
//     width: "100%",
//     padding: "16px",
//     borderRadius: "12px",
//     border: "2px solid #E2E8F0",
//     fontSize: "16px",
//     transition: "all 0.3s ease",
//     boxSizing: "border-box",
//     background: "white",
//   };

//   const buttonStyles = {
//     width: "100%",
//     padding: "16px",
//     borderRadius: "12px",
//     border: "none",
//     color: "white",
//     fontSize: "16px",
//     fontWeight: "600",
//     transition: "all 0.3s ease",
//     position: "relative",
//     overflow: "hidden",
//   };

//   const signupTextStyles = {
//   color: "#718096",
//    fontSize: "14px",
//    margin: 0,
//  };

 
//  const signupLinkStyles = {
//   color: "#667eea",
//    fontWeight: "600",
//    textDecoration: "none",
//    cursor: "pointer",
//  };

//   const spinnerStyles = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: "20px",
//     height: "20px",
//     border: "2px solid transparent",
//     borderTop: "2px solid white",
//     borderRadius: "50%",
//     animation: "spin 1s linear infinite",
//   };

//   return (
//     <div style={containerStyles}>
//       {/* Animated Background Elements */}
//       <div style={backgroundElement1} />
//       <div style={backgroundElement2} />
//       <div style={backgroundElement3} />

//       {/* Main Container */}
//       <div style={mainContainerStyles}>
//         {/* Left Side - Dairy Illustration */}
//         <div style={illustrationStyles}>
//           <div style={iconContainerStyles}>
//             <span style={iconStyles}>🥛</span>
//           </div>
//           <h1 style={titleStyles}>Dairy Management System</h1>
//           <p style={descriptionStyles}>
//             Sign in to access your dairy farm management dashboard, track production, and manage inventory.
//           </p>
//           <div style={featuresContainerStyles}>
//             {["Production Tracking", "Inventory Management", "Sales Analytics"].map((feature) => (
//               <span key={feature} style={featureStyles}>
//                 {feature}
//               </span>
//             ))}
//           </div>
//         </div>

//         {/* Right Side - Form */}
//         <div style={formContainerStyles}>
//           <form onSubmit={handleLogin} style={loginFormStyles}>
//             <div style={{ textAlign: "center", marginBottom: "30px" }}>
//               <h2 style={formTitleStyles}>Sign In</h2>
//               <p style={formSubtitleStyles}>Enter your credentials to access the system</p>
//             </div>

//             <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
//               {/* Username Field */}
//               <div>
//                 <label style={labelStyles}>Username</label>
//                 <input
//                   type="text"
//                   placeholder="Enter your username"
//                   value={username}
//                   onChange={(e) => setUsername(e.target.value)}
//                   style={inputStyles}
//                   onFocus={(e) => e.target.style.borderColor = "#ffa916"}
//                   onBlur={(e) => e.target.style.borderColor = "#E2E8F0"}
//                 />
//               </div>

//               {/* Password Field with Show/Hide */}
//               <div>
//                 <label style={labelStyles}>Password</label>
//                 <PasswordInput
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="Enter your password"
//                   style={{
//                     ...inputStyles,
//                     paddingRight: "60px"
//                   }}
//                 />
//               </div>

//               {/* Role Selection */}
//               <div>
//                 <label style={labelStyles}>
//                   Role
//                   {fetchingRoles && <span style={loadingTextStyles}>Loading roles...</span>}
//                 </label>
//                 <select
//                   value={role}
//                   onChange={(e) => setRole(e.target.value)}
//                   disabled={fetchingRoles || roles.length === 0}
//                   style={selectStyles}
//                   onFocus={(e) => e.target.style.borderColor = "#ffa916"}
//                   onBlur={(e) => e.target.style.borderColor = "#E2E8F0"}
//                 >
//                   {fetchingRoles ? (
//                     <option value="">Loading roles...</option>
//                   ) : roles.length === 0 ? (
//                     <option value="">No roles available</option>
//                   ) : (
//                     <>
//                       <option value="">Select a role</option>
//                       {roles.map((roleItem) => (
//                         <option key={roleItem.id} value={roleItem.id}>
//                           {roleItem.name.charAt(0).toUpperCase() + roleItem.name.slice(1)}
//                         </option>
//                       ))}
//                     </>
//                   )}
//                 </select>
//               </div>

//               {/* Remember Me & Forgot Password */}
//               <div style={actionsContainerStyles}>
//                 <label style={rememberMeStyles} onClick={handleRememberMe}>
//                   <input type="checkbox" style={checkboxStyles} />
//                   Remember me
//                 </label>
//                 <Link
//                   to="/forgot-password"
//                   style={forgotPasswordLinkStyles}
//                 >
//                   Forgot password?
//                 </Link>
//               </div>

//               {/* Login Button */}
//               <button
//                 type="submit"
//                 disabled={loading || fetchingRoles || !role}
//                 style={{
//                   ...loginButtonStyles,
//                   opacity: (loading || fetchingRoles || !role) ? 0.7 : 1,
//                   cursor: (loading || fetchingRoles || !role) ? "not-allowed" : "pointer",
//                 }}
//                 onMouseOver={(e) => {
//                   if (!loading && !fetchingRoles && role) {
//                     e.target.style.transform = "translateY(-2px)";
//                     e.target.style.boxShadow = "0 6px 12px rgba(255, 169, 22, 0.3)";
//                   }
//                 }}
//                 onMouseOut={(e) => {
//                   if (!loading && !fetchingRoles && role) {
//                     e.target.style.transform = "translateY(0)";
//                     e.target.style.boxShadow = "0 4px 8px rgba(255, 169, 22, 0.2)";
//                   }
//                 }}
//               >
//                 {loading ? (
//                   <>
//                     <span style={{ opacity: 0 }}>Sign In</span>
//                     <div style={spinnerStyles} />
//                   </>
//                 ) : fetchingRoles ? (
//                   "Loading Roles..."
//                 ) : (
//                   "Sign In"
//                 )}
//               </button>

//               {/* Sign Up Link */}
//                  <div style={{ textAlign: "center", marginTop: "20px" }}>
//                   <p style={signupTextStyles}>
//                      Don't have an account?{" "}
//                      <a
//                        href="/register"
//                       onClick={(e) => {
//                          e.preventDefault();
//                          navigate("/register");
//                        }}
//                        style={signupLinkStyles}
//                     >
//                        Sign up
//                      </a>
//                   </p>
//                  </div>
//             </div>
//           </form>
//         </div>
//       </div>

//       <style>{animationStyles}</style>
//     </div>
//   );
// };

// // Styles - Updated with dairy theme and main colors
// const containerStyles = {
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   minHeight: "100vh",
//   background: "linear-gradient(135deg, #024a59 0%, #027387 100%)",
//   fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
//   padding: "20px",
//   position: "relative",
//   overflow: "hidden",
// };

// const backgroundElement1 = {
//   position: "absolute",
//   top: "-10%",
//   left: "-10%",
//   width: "300px",
//   height: "300px",
//   borderRadius: "50%",
//   background: "rgba(255, 255, 255, 0.1)",
//   animation: "float 8s ease-in-out infinite",
// };

// const backgroundElement2 = {
//   position: "absolute",
//   bottom: "-15%",
//   right: "-5%",
//   width: "400px",
//   height: "400px",
//   borderRadius: "50%",
//   background: "rgba(255, 255, 255, 0.05)",
//   animation: "float 12s ease-in-out infinite",
//   animationDelay: "2s",
// };

// const backgroundElement3 = {
//   position: "absolute",
//   top: "20%",
//   right: "30%",
//   width: "120px",
//   height: "120px",
//   borderRadius: "50%",
//   background: "rgba(255, 255, 255, 0.08)",
//   animation: "float 6s ease-in-out infinite",
//   animationDelay: "1s",
// };

// const mainContainerStyles = {
//   display: "flex",
//   flexDirection: "row",
//   alignItems: "center",
//   justifyContent: "center",
//   width: "100%",
//   maxWidth: "1200px",
//   gap: "60px",
//   animation: "slideUp 0.8s ease-out",
// };

// const illustrationStyles = {
//   flex: 1,
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center",
//   textAlign: "center",
//   color: "white",
//   animation: "fadeIn 1s ease-out",
// };

// const iconContainerStyles = {
//   width: "200px",
//   height: "200px",
//   borderRadius: "50%",
//   background: "rgba(255, 255, 255, 0.2)",
//   backdropFilter: "blur(10px)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   marginBottom: "30px",
//   animation: "pulse 3s infinite",
//   border: "2px solid rgba(255, 255, 255, 0.3)",
// };

// const iconStyles = {
//   fontSize: "80px",
//   filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.2))",
// };

// const titleStyles = {
//   fontSize: "36px",
//   fontWeight: "700",
//   marginBottom: "10px",
//   textShadow: "0 2px 4px rgba(0,0,0,0.3)",
// };

// const descriptionStyles = {
//   fontSize: "18px",
//   opacity: 0.9,
//   lineHeight: 1.5,
//   maxWidth: "400px",
//   textShadow: "0 1px 2px rgba(0,0,0,0.2)",
// };

// const featuresContainerStyles = {
//   display: "flex",
//   gap: "15px",
//   marginTop: "30px",
//   flexWrap: "wrap",
//   justifyContent: "center",
// };

// const featureStyles = {
//   background: "rgba(255, 255, 255, 0.2)",
//   padding: "8px 16px",
//   borderRadius: "20px",
//   fontSize: "14px",
//   backdropFilter: "blur(10px)",
//   border: "1px solid rgba(255, 255, 255, 0.3)",
// };

// const formContainerStyles = {
//   flex: "0 0 400px",
//   width: "100%",
//   maxWidth: "450px",
// };

// const loginFormStyles = {
//   background: "rgba(255, 255, 255, 0.95)",
//   backdropFilter: "blur(20px)",
//   borderRadius: "24px",
//   padding: "40px 35px",
//   boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
//   border: "1px solid rgba(255, 255, 255, 0.3)",
//   animation: "slideInRight 0.8s ease-out",
// };

// const formTitleStyles = {
//   margin: "0 0 8px 0",
//   color: "#024a59",
//   fontSize: "28px",
//   fontWeight: "700",
// };

// const formSubtitleStyles = {
//   color: "#718096",
//   margin: 0,
//   fontSize: "14px",
// };

// const labelStyles = {
//   display: "block",
//   marginBottom: "8px",
//   color: "#4A5568",
//   fontWeight: "600",
//   fontSize: "14px",
// };

// const loadingTextStyles = {
//   color: "#ffa916",
//   marginLeft: "8px",
//   fontSize: "12px",
// };

// const selectStyles = {
//   width: "100%",
//   padding: "16px",
//   borderRadius: "12px",
//   border: "2px solid #E2E8F0",
//   fontSize: "16px",
//   background: "white",
//   transition: "all 0.3s ease",
//   boxSizing: "border-box",
// };

// const actionsContainerStyles = {
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   fontSize: "14px",
// };

// const rememberMeStyles = {
//   display: "flex",
//   alignItems: "center",
//   gap: "8px",
//   color: "#4A5568",
//   cursor: "pointer",
// };

// const checkboxStyles = {
//   width: "16px",
//   height: "16px",
//   cursor: "pointer",
// };

// const forgotPasswordLinkStyles = {
//   color: "#ffa916",
//   textDecoration: "none",
//   fontWeight: "600",
//   cursor: "pointer",
// };

// const loginButtonStyles = {
//   width: "100%",
//   padding: "16px",
//   borderRadius: "12px",
//   border: "none",
//   background: "#ffa916",
//   color: "white",
//   fontSize: "16px",
//   fontWeight: "600",
//   transition: "all 0.3s ease",
//   position: "relative",
//   overflow: "hidden",
//   marginTop: "10px",
//   boxShadow: "0 4px 8px rgba(255, 169, 22, 0.2)",
// };

// const animationStyles = `
//   @keyframes slideUp {
//     from { opacity: 0; transform: translateY(30px); }
//     to { opacity: 1; transform: translateY(0); }
//   }
  
//   @keyframes slideInRight {
//     from { opacity: 0; transform: translateX(30px); }
//     to { opacity: 1; transform: translateX(0); }
//   }
  
//   @keyframes fadeIn {
//     from { opacity: 0; }
//     to { opacity: 1; }
//   }
  
//   @keyframes pulse {
//     0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4); }
//     70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(255, 255, 255, 0); }
//     100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); }
//   }
  
//   @keyframes float {
//     0%, 100% { transform: translateY(0) rotate(0deg); }
//     50% { transform: translateY(-20px) rotate(5deg); }
//   }
  
//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }

//   input:focus, select:focus {
//     outline: none;
//     border-color: #ffa916 !important;
//     box-shadow: 0 0 0 3px rgba(255, 169, 22, 0.1);
//   }

//   input:hover, select:hover {
//     border-color: #ffa916;
//   }

//   @media (max-width: 768px) {
//     .main-container {
//       flex-direction: column;
//       gap: 30px;
//     }
    
//     .illustration {
//       order: 2;
//     }
    
//     .form-container {
//       order: 1;
//       flex: 1;
//       max-width: 100%;
//     }
    
//     .icon-container {
//       width: 150px;
//       height: 150px;
//     }
    
//     .icon {
//       font-size: 60px;
//     }
    
//     .title {
//       font-size: 28px;
//     }
    
//     .description {
//       font-size: 16px;
//     }
    
//     .features-container {
//       flex-direction: column;
//       align-items: center;
//     }
//   }

//   @media (max-width: 480px) {
//     .login-form {
//       padding: 30px 20px;
//     }
    
//     .title {
//       font-size: 24px;
//     }
    
//     .form-title {
//       font-size: 24px;
//     }
    
//     .actions-container {
//       flex-direction: column;
//       gap: 10px;
//       align-items: flex-start;
//     }
//   }
// `;

// export default LoginPage;


import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import swal from "sweetalert";

// Move PasswordInput component outside the main component to prevent recreation
const PasswordInput = React.memo(({ value, onChange, placeholder, style }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={style}
      />
      <button
        type="button"
        onClick={togglePasswordVisibility}
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          background: "none",
          border: "none",
          color: "#024a59",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: "600",
          padding: "4px 8px",
          borderRadius: "4px",
        }}
        onMouseOver={(e) => (e.target.style.background = "rgba(2, 74, 89, 0.1)")}
        onMouseOut={(e) => (e.target.style.background = "none")}
      >
        {showPassword ? "Hide" : "Show"}
      </button>
    </div>
  );
});

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [fetchingRoles, setFetchingRoles] = useState(true);

  const navigate = useNavigate();

  // Check screen size for responsiveness
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Fetch roles from database
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        setFetchingRoles(true);
        const response = await fetch("https://dairy.server.statify.co.ke/api/users/roles", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch roles");
        }

        const rolesData = await response.json();
        setRoles(rolesData);

        if (rolesData.length > 0) {
          setRole(rolesData[0].id.toString());
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
        swal({
          title: "Connection Error",
          text: "Unable to load roles. Please check your connection and try again.",
          icon: "error",
          button: "Try Again",
        }).then(() => {
          fetchRoles();
        });
      } finally {
        setFetchingRoles(false);
      }
    };

    fetchRoles();
  }, []);

  // Corrected Login Function - Validates role properly
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password || !role) {
      swal({
        title: "Missing Information",
        text: "Please fill in all fields to continue",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    if (username.length < 3) {
      swal({
        title: "Invalid Username",
        text: "Username must be at least 3 characters long",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    if (password.length < 6) {
      swal({
        title: "Weak Password",
        text: "Password must be at least 6 characters long",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    setLoading(true);

    swal({
      title: "Signing In...",
      text: "Please wait while we authenticate your credentials",
      icon: "info",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
    });

    try {
      const response = await fetch("https://dairy.server.statify.co.ke/api/users/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          password,
          role_id: parseInt(role),
        }),
      });

      const data = await response.json();

      if (response.ok) {
        swal.close();

        // Validate if the user has permission for the selected role
        if (
          data.role &&
          data.role.toLowerCase() !==
            roles.find((r) => r.id === parseInt(role))?.name.toLowerCase()
        ) {
          swal({
            title: "Role Mismatch",
            text: "You don't have permission to access this role. Please select the correct role for your account.",
            icon: "error",
            button: "OK",
          });
          setLoading(false);
          return;
        }

        swal({
          title: "Login Successful!",
          text: `Welcome back, ${username}! Redirecting to dashboard...`,
          icon: "success",
          timer: 2000,
          buttons: false,
        }).then(() => {
          localStorage.setItem("token", data.access_token);
          localStorage.setItem("role", data.role);
          localStorage.setItem("username", username);
          localStorage.setItem("userRoleId", role);

          if (onLogin) {
            onLogin();
          }

          navigate("/dashboard");
        });
      } else {
        swal({
          title: "Login Failed",
          text: data.error || "Invalid credentials. Please try again.",
          icon: "error",
          button: "Try Again",
        });
      }
    } catch (err) {
      swal({
        title: "Connection Error",
        text: "Unable to connect to the server. Please check your internet connection and try again.",
        icon: "error",
        button: "OK",
      });
    }

    setLoading(false);
  };

  const handleRememberMe = () => {
    swal({
      title: "Remember Me",
      text: "This will keep you signed in for 30 days on this device. Only use on trusted devices.",
      icon: "info",
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "I Understand",
          value: true,
        },
      },
    });
  };

  // Input Styles - Moved outside to prevent recreation
  const inputStyles = {
    width: "100%",
    padding: "16px",
    borderRadius: "12px",
    border: "2px solid #E2E8F0",
    fontSize: "16px",
    transition: "all 0.3s ease",
    boxSizing: "border-box",
    background: "white",
  };

  const passwordInputStyle = {
    ...inputStyles,
    paddingRight: "60px",
  };

  const buttonStyles = {
    width: "100%",
    padding: "16px",
    borderRadius: "12px",
    border: "none",
    color: "white",
    fontSize: "16px",
    fontWeight: "600",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden",
  };

  const signupTextStyles = {
    color: "#718096",
    fontSize: "14px",
    margin: 0,
  };

  const signupLinkStyles = {
    color: "#667eea",
    fontWeight: "600",
    textDecoration: "none",
    cursor: "pointer",
  };

  const spinnerStyles = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "20px",
    height: "20px",
    border: "2px solid transparent",
    borderTop: "2px solid white",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  return (
    <div style={containerStyles}>
      {/* Animated Background Elements */}
      <div style={backgroundElement1} />
      <div style={backgroundElement2} />
      <div style={backgroundElement3} />

      {/* Main Container */}
      <div style={mainContainerStyles}>
        {/* Left Side - Dairy Illustration */}
        <div style={illustrationStyles}>
          <div style={iconContainerStyles}>
            <span style={iconStyles}>🥛</span>
          </div>
          <h1 style={titleStyles}>Dairy Management System</h1>
          <p style={descriptionStyles}>
            Sign in to access your dairy farm management dashboard, track production, and manage inventory.
          </p>
          <div style={featuresContainerStyles}>
            {["Production Tracking", "Inventory Management", "Sales Analytics"].map((feature) => (
              <span key={feature} style={featureStyles}>
                {feature}
              </span>
            ))}
          </div>
        </div>

        {/* Right Side - Form */}
        <div style={formContainerStyles}>
          <form onSubmit={handleLogin} style={loginFormStyles}>
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
              <h2 style={formTitleStyles}>Sign In</h2>
              <p style={formSubtitleStyles}>Enter your credentials to access the system</p>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              {/* Username Field */}
              <div>
                <label style={labelStyles}>Username</label>
                <input
                  type="text"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  style={inputStyles}
                  onFocus={(e) => (e.target.style.borderColor = "#ffa916")}
                  onBlur={(e) => (e.target.style.borderColor = "#E2E8F0")}
                />
              </div>

              {/* Password Field with Show/Hide */}
              <div>
                <label style={labelStyles}>Password</label>
                <PasswordInput
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  style={passwordInputStyle}
                />
              </div>

              {/* Role Selection */}
              <div>
                <label style={labelStyles}>
                  Role
                  {fetchingRoles && <span style={loadingTextStyles}>Loading roles...</span>}
                </label>
                <select
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  disabled={fetchingRoles || roles.length === 0}
                  style={selectStyles}
                  onFocus={(e) => (e.target.style.borderColor = "#ffa916")}
                  onBlur={(e) => (e.target.style.borderColor = "#E2E8F0")}
                >
                  {fetchingRoles ? (
                    <option value="">Loading roles...</option>
                  ) : roles.length === 0 ? (
                    <option value="">No roles available</option>
                  ) : (
                    <>
                      <option value="">Select a role</option>
                      {roles.map((roleItem) => (
                        <option key={roleItem.id} value={roleItem.id}>
                          {roleItem.name.charAt(0).toUpperCase() + roleItem.name.slice(1)}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>

              {/* Remember Me & Forgot Password */}
              <div style={actionsContainerStyles}>
                <label style={rememberMeStyles} onClick={handleRememberMe}>
                  <input type="checkbox" style={checkboxStyles} />
                  Remember me
                </label>
                <Link to="/forgot-password" style={forgotPasswordLinkStyles}>
                  Forgot password?
                </Link>
              </div>

              {/* Login Button */}
              <button
                type="submit"
                disabled={loading || fetchingRoles || !role}
                style={{
                  ...loginButtonStyles,
                  opacity: loading || fetchingRoles || !role ? 0.7 : 1,
                  cursor: loading || fetchingRoles || !role ? "not-allowed" : "pointer",
                }}
                onMouseOver={(e) => {
                  if (!loading && !fetchingRoles && role) {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 6px 12px rgba(255, 169, 22, 0.3)";
                  }
                }}
                onMouseOut={(e) => {
                  if (!loading && !fetchingRoles && role) {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 8px rgba(255, 169, 22, 0.2)";
                  }
                }}
              >
                {loading ? (
                  <>
                    <span style={{ opacity: 0 }}>Sign In</span>
                    <div style={spinnerStyles} />
                  </>
                ) : fetchingRoles ? (
                  "Loading Roles..."
                ) : (
                  "Sign In"
                )}
              </button>

              {/* Sign Up Link */}
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <p style={signupTextStyles}>
                  Don't have an account?{" "}
                  <a
                    href="/register"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/register");
                    }}
                    style={signupLinkStyles}
                  >
                    Sign up
                  </a>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>

      <style>{animationStyles}</style>
    </div>
  );
};

// All the style constants remain the same as your original code
const containerStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  background: "linear-gradient(135deg, #024a59 0%, #027387 100%)",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  padding: "20px",
  position: "relative",
  overflow: "hidden",
};

const backgroundElement1 = {
  position: "absolute",
  top: "-10%",
  left: "-10%",
  width: "300px",
  height: "300px",
  borderRadius: "50%",
  background: "rgba(255, 255, 255, 0.1)",
  animation: "float 8s ease-in-out infinite",
};

const backgroundElement2 = {
  position: "absolute",
  bottom: "-15%",
  right: "-5%",
  width: "400px",
  height: "400px",
  borderRadius: "50%",
  background: "rgba(255, 255, 255, 0.05)",
  animation: "float 12s ease-in-out infinite",
  animationDelay: "2s",
};

const backgroundElement3 = {
  position: "absolute",
  top: "20%",
  right: "30%",
  width: "120px",
  height: "120px",
  borderRadius: "50%",
  background: "rgba(255, 255, 255, 0.08)",
  animation: "float 6s ease-in-out infinite",
  animationDelay: "1s",
};

const mainContainerStyles = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  maxWidth: "1200px",
  gap: "60px",
  animation: "slideUp 0.8s ease-out",
};

const illustrationStyles = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  color: "white",
  animation: "fadeIn 1s ease-out",
};

const iconContainerStyles = {
  width: "200px",
  height: "200px",
  borderRadius: "50%",
  background: "rgba(255, 255, 255, 0.2)",
  backdropFilter: "blur(10px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "30px",
  animation: "pulse 3s infinite",
  border: "2px solid rgba(255, 255, 255, 0.3)",
};

const iconStyles = {
  fontSize: "80px",
  filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.2))",
};

const titleStyles = {
  fontSize: "36px",
  fontWeight: "700",
  marginBottom: "10px",
  textShadow: "0 2px 4px rgba(0,0,0,0.3)",
};

const descriptionStyles = {
  fontSize: "18px",
  opacity: 0.9,
  lineHeight: 1.5,
  maxWidth: "400px",
  textShadow: "0 1px 2px rgba(0,0,0,0.2)",
};

const featuresContainerStyles = {
  display: "flex",
  gap: "15px",
  marginTop: "30px",
  flexWrap: "wrap",
  justifyContent: "center",
};

const featureStyles = {
  background: "rgba(255, 255, 255, 0.2)",
  padding: "8px 16px",
  borderRadius: "20px",
  fontSize: "14px",
  backdropFilter: "blur(10px)",
  border: "1px solid rgba(255, 255, 255, 0.3)",
};

const formContainerStyles = {
  flex: "0 0 400px",
  width: "100%",
  maxWidth: "450px",
};

const loginFormStyles = {
  background: "rgba(255, 255, 255, 0.95)",
  backdropFilter: "blur(20px)",
  borderRadius: "24px",
  padding: "40px 35px",
  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
  border: "1px solid rgba(255, 255, 255, 0.3)",
  animation: "slideInRight 0.8s ease-out",
};

const formTitleStyles = {
  margin: "0 0 8px 0",
  color: "#024a59",
  fontSize: "28px",
  fontWeight: "700",
};

const formSubtitleStyles = {
  color: "#718096",
  margin: 0,
  fontSize: "14px",
};

const labelStyles = {
  display: "block",
  marginBottom: "8px",
  color: "#4A5568",
  fontWeight: "600",
  fontSize: "14px",
};

const loadingTextStyles = {
  color: "#ffa916",
  marginLeft: "8px",
  fontSize: "12px",
};

const selectStyles = {
  width: "100%",
  padding: "16px",
  borderRadius: "12px",
  border: "2px solid #E2E8F0",
  fontSize: "16px",
  background: "white",
  transition: "all 0.3s ease",
  boxSizing: "border-box",
};

const actionsContainerStyles = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "14px",
};

const rememberMeStyles = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  color: "#4A5568",
  cursor: "pointer",
};

const checkboxStyles = {
  width: "16px",
  height: "16px",
  cursor: "pointer",
};

const forgotPasswordLinkStyles = {
  color: "#ffa916",
  textDecoration: "none",
  fontWeight: "600",
  cursor: "pointer",
};

const loginButtonStyles = {
  width: "100%",
  padding: "16px",
  borderRadius: "12px",
  border: "none",
  background: "#ffa916",
  color: "white",
  fontSize: "16px",
  fontWeight: "600",
  transition: "all 0.3s ease",
  position: "relative",
  overflow: "hidden",
  marginTop: "10px",
  boxShadow: "0 4px 8px rgba(255, 169, 22, 0.2)",
};

const animationStyles = `
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes slideInRight {
    from { opacity: 0; transform: translateX(30px); }
    to { opacity: 1; transform: translateX(0); }
  }
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  @keyframes pulse {
    0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4); }
    70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(255, 255, 255, 0); }
    100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); }
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(5deg); }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  input:focus, select:focus {
    outline: none;
    border-color: #ffa916 !important;
    box-shadow: 0 0 0 3px rgba(255, 169, 22, 0.1);
  }

  input:hover, select:hover {
    border-color: #ffa916;
  }

  @media (max-width: 768px) {
    .main-container {
      flex-direction: column;
      gap: 30px;
    }
    
    .illustration {
      order: 2;
    }
    
    .form-container {
      order: 1;
      flex: 1;
      max-width: 100%;
    }
    
    .icon-container {
      width: 150px;
      height: 150px;
    }
    
    .icon {
      font-size: 60px;
    }
    
    .title {
      font-size: 28px;
    }
    
    .description {
      font-size: 16px;
    }
    
    .features-container {
      flex-direction: column;
      align-items: center;
    }
  }

  @media (max-width: 480px) {
    .login-form {
      padding: 30px 20px;
    }
    
    .title {
      font-size: 24px;
    }
    
    .form-title {
      font-size: 24px;
    }
    
    .actions-container {
      flex-direction: column;
      gap: 10px;
      align-items: flex-start;
    }
  }
`;

export default LoginPage;